import type { GraphQLTypes, InputType } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const questionFields = { id: true, position: true, kind: true, label: true, isOverall: true } as const

/** Le questionnaire de fin de parcours d'un apprenant, et s'il est à proposer (#320). */
export const GQL_MY_SURVEY = typedGql('query', { scalars })({
  mySurvey: [{ sessionId: $('sessionId', 'ID!') }, { pending: true, questions: questionFields, modules: { id: true, title: true } }],
})

export const GQL_SUBMIT_SURVEY = typedGql('mutation', { scalars })({
  submitSurvey: [{ input: $('input', 'SubmitSurveyInput!') }, true],
})

export const GQL_SKIP_SURVEY = typedGql('mutation', { scalars })({
  skipSurvey: [{ sessionId: $('sessionId', 'ID!') }, true],
})

/** Résultats d'un parcours, agrégés et sans nom. */
const surveyResultsFields = {
  answered: true,
  skipped: true,
  satisfactionRate: true,
  questions: { questionId: true, label: true, average: true, count: true },
  modules: { moduleId: true, title: true, average: true, count: true },
  comments: { label: true, text: true, at: true },
} as const

export const GQL_SURVEY_RESULTS = typedGql('query', { scalars })({
  surveyResults: [{ sessionId: $('sessionId', 'ID!') }, surveyResultsFields],
})

export type SurveyResults = InputType<GraphQLTypes['SurveyResultsModel'], typeof surveyResultsFields, typeof scalars>

export const GQL_SURVEY_QUESTIONS = typedGql('query', { scalars })({
  surveyQuestions: questionFields,
})

export const GQL_REPLACE_SURVEY_QUESTIONS = typedGql('mutation', { scalars })({
  replaceSurveyQuestions: [{ questions: $('questions', '[SurveyQuestionInput!]!') }, questionFields],
})

export type LearnerSurvey = InputType<GraphQLTypes['LearnerSurveyModel'], { pending: true, questions: typeof questionFields, modules: { id: true, title: true } }, typeof scalars>
export type SurveyQuestion = LearnerSurvey['questions'][number]
